const Card = ({ children, hasError }: { children: React.ReactNode; hasError?: boolean }) => {
    return (
        <div
            className={`rounded-2xl border  bg-white p-5 dark:bg-white/[0.03] lg:p-6 ${
                hasError ? 'border-red-500' : 'border-gray-200 dark:border-gray-700'
            }`}
        >
            {children}
        </div>
    )
}

export default Card
